import React, { Component } from 'react';
import { Switch, Route, Link } from 'react-router-dom';

import Forydeb from '../components/types/Forydeb';
import Description from '../components/types/Description';
import Top5 from '../components/types/Top5';

export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tipo_id: this.props.match.params.id,
      carreras: [],
      strengths: [],
      weaknesses: [],
      careers: [],
      user: JSON.parse(localStorage.getItem('tpuser')),
    };
  }

  componentDidMount() {
    fetch(
      process.env.REACT_APP_API_URL +
        '/type/' +
        this.state.tipo_id.toUpperCase(),
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);

        this.setState(data);
      });
  }

  render() {
    let descripcion_titulo = (
      <div className='b-bottom text-justify-center offset-md-3 col-xs-12 col-md-8'>
        <h1 className='media-margin title'>{this.state.name}</h1>
        <h2 className=' media-center'>
          <b>
            {this.state.code} / {this.state._code}
          </b>
        </h2>
      </div>
    );

    const sex = this.state.user.sex == 'female' ? 'F' : 'M';

    let img = (
      <img
        src={'/img-tipos/' + this.state.code + '_' + sex + 'small.svg'}
        className='img-75 margin-top--100 d-none d-sm-block ml-8'
      />
    );

    return (
      <div className='container'>
        <img
          src={'/img-tipos/' + this.state.code + '_' + sex + 'small.svg'}
          className='img-50 d-block d-sm-none img-center'
        />
        {descripcion_titulo}

        <div className='row'>
          <div className='col-md-3 border-right-1 hidden-sm-down offset-md-1'>
            {img}

            <div className='text-left mt-5'>
              <Link
                className='btn btn-block btn-lg btn-black'
                to={'/bars/' + this.state.tipo_id + '/descripcion'}>
                Perfil
              </Link>

              <br />

              <Link
                className='btn btn-block btn-lg btn-black'
                to={'/bars/' + this.state.tipo_id + '/fortalezas-debilidades'}>
                Fortalezas y Debilidades
              </Link>

              <br />

              <Link
                className='btn btn-block btn-lg btn-black'
                to={'/bars/' + this.state.tipo_id + '/carreras-top'}>
                Carreras Top
              </Link>
            </div>
          </div>

          <div
            className='col-md-7 col-xs-12 media-texto backwhite'
            style={{ fontSize: '1.2rem', textAlign: 'justify' }}>
            <Switch>
              <Route
                exact
                path='/bars/:id'
                render={() => (
                  <Description
                    content={this.state.description}
                    quote={this.state.quote}
                    autor={this.state.author}
                  />
                )}
              />
              <Route
                exact
                path='/bars/:id/descripcion'
                render={() => (
                  <Description
                    content={this.state.description}
                    quote={this.state.quote}
                    autor={this.state.author}
                  />
                )}
              />
              <Route
                exact
                path='/bars/:id/fortalezas-debilidades'
                render={() => (
                  <Forydeb
                    fortalezas={this.state.strengths}
                    debilidades={this.state.weaknesses}
                  />
                )}
              />
              <Route
                exact
                path='/bars/:id/carreras-top'
                render={() => (
                  <Top5
                    carreras={this.state.careers}
                    d_carreras={this.state.d_careers}
                    d_carreras_2={this.state.d_careers_2}
                  />
                )}
              />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Profile.jsx